// JWT utility functions
export function decodeJWT(token) {
  try {
    if (!token) return null;
    const base64Url = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64Url)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    // console.error("Error decoding JWT:", e);
    return null;
  }
}